import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventsComponent } from './events.component';
import { SharedModule } from '@shared/shared.module';
import { CreateComponent } from './pages/create/create.component';
import { TagInputModule } from 'ngx-chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailEventResolve } from '@shared/resolvers/detail-event.resolve';
import { ProjectModuleWithoutRouting } from '@layouts/default/layouts/logged/pages/project/project.module-without-routing';
import { PhotoThemePreviewComponent } from './components/photo-theme-preview/photo-theme-preview.component';

const routes: Routes = [
  { path: 'create', component: CreateComponent },
  { path: 'edit/:id', component: CreateComponent, resolve: { editEvent: DetailEventResolve } },
];

@NgModule({
  declarations: [
      PhotoThemePreviewComponent,
      EventsComponent,
      CreateComponent
  ],
    imports: [
        RouterModule.forChild(routes),
        SharedModule,
        TagInputModule,
        FormsModule,
        ReactiveFormsModule,
        ProjectModuleWithoutRouting
    ],
})
export class EventsModule {}
